import PaginationRequest from '../../../../Common/RequestModels/PaginationRequest';
import SearchRequest from '../../../../Spirit/Common/Extensions/Models/SearchRequest';
import SortRequest from '../../../../Spirit/Common/Extensions/Models/SortRequest';

export default class FilterRequest  {
	Pagination: PaginationRequest = null;
	Search: Array<SearchRequest> = null;
	Sort: SortRequest = null;
	constructor(obj?: Partial<FilterRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
